// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoPoster__root video-poster","adPoster":"VideoPoster__adPoster","adMessage":"VideoPoster__adMessage font-style--header-3 font-size--copy--large"};
    if(module.hot) {
      // 1790535707153
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  